export default __webpack_public_path__ + "static/media/img_si_more.a9710483.png";